import { render, staticRenderFns } from "./LenderBox.vue?vue&type=template&id=2841061f&scoped=true&"
import script from "./LenderBox.vue?vue&type=script&lang=js&"
export * from "./LenderBox.vue?vue&type=script&lang=js&"
import style0 from "./LenderBox.vue?vue&type=style&index=0&id=2841061f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2841061f",
  null
  
)

export default component.exports